import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const staticDataDetailsSearchSchema = z.object({
  sysId: z.coerce.number(),
  wiid: z.coerce.number(),
  ticketType: z.string(),
});

export type StaticDataDetailsSearch = z.infer<
  typeof staticDataDetailsSearchSchema
>;

export const Route = createFileRoute("/static-data-details")({
  validateSearch: staticDataDetailsSearchSchema,
  staticData: { breadcrumb: "Static Details" },
});
